import React, { Component } from "react";
import { Configurations } from "../../Utils/Configurations";
import axios from "axios";

class AmazonBilling extends Component {
  constructor() {
    super();

    this.clickEnviaFaturamento = this.clickEnviaFaturamento.bind(this);

    this.Configurations = new Configurations();

    this.state = {
      isLoading: false,
      pedidos: [],
    };
  }

  handleError(err) {
    this.setState({ hasError: true, errorMessage: err.response.data.message });
  }

  clickEnviaFaturamento() {
    this.setState({
      isLoading: true,
    });
    const _faturamento = axios.get(
      this.Configurations.apiBasePath + `/importar-amazon`
    );

    _faturamento
      .then((response) => {
        if (response.data.ErroImportacao !== "") {
          this.handleError({
            err: {
              response: {
                data: {
                  message: response.data.ErroImportacao,
                },
              },
            },
          });
        }
        this.setState({
          pedidos: response.data.data,
          isLoading: false,
        });
      })
      .catch(this.handleError);
  }

  render() {
    return (
      <div className="faturamento">
        <div className="row">
          <div className="col-12 col-md-8 offset-md-2 text-center">
            <h2>Faturamento Amazon</h2>
          </div>
          <div className="col-12 col-md-8 offset-md-2 text-center">
            <p>
              Clique no botão abaixo para enviar os pedidos que estão pendentes de criação de pedido de venda no Protheus EBS. Após a conclusão do processo será exibida a lista de números de pedidos que tiveram processamento bem-sucedido. É possível que nem todos os pedidos possam ser enviados.
            </p>
          </div>
          <div className="col-12 col-md-8 offset-md-2 text-center">
            <button
              type="button"
              class="btn btn-primary"
              onClick={this.clickEnviaFaturamento}
              disabled={this.state.isLoading}
            >
              <i
                className={`fas ${
                  this.state.isLoading ? "fa-spinner fa-spin" : "fa-paper-plane"
                } mr-2`}
              ></i>{" "}
              {this.state.isLoading
                ? "Enviando pedidos para faturamento, por gentileza, aguarde"
                : "Enviar pedidos para faturamento"}
            </button>
          </div>
          {this.state.pedidos.length > 0 ? (
            <div className="col-12 col-md-4 offset-md-4 mt-4">
              <p>
                Esses foram os pedidos enviados com sucesso para faturamento
              </p>
              <div className="card">
                <table className="table table-striped">
                  <tr>
                    <th className="text-center">#</th>
                    <th className="text-center">Número do pedido</th>
                  </tr>
                  {this.state.pedidos.map((p, index) => (
                    <tr key={index}>
                      <td className="text-center">{index}</td>
                      <td className="text-center">{p}</td>
                    </tr>
                  ))}
                </table>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default AmazonBilling;
